<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" :btns="btns" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
// import Wxts from '../../../components/Wxts.vue';

export default {
  mixins: [tableMixin],
  // components: { Wxts },
  data() {
    return {
      baseUrl: 'cap',
      breadcrumb: [
        { name: "财务管理", path: `/finance/accounts` },
        { name: "合同账款管理", path: `/finance/accounts` },
      ],
      wxtsList: [
        {
          name: '应收运费=运费总额-亏吨金额+运单补差+合同补差'
        },
        {
          name: '应付运费=承运运费-亏吨金额'
        }
      ],
      formInline: {},
      formCtrl: [
        {
          label: "合同编号",
          keyName: "con_num",
          placeholder: "请填写合同编号",
          type: "text",
        },
        {
          label: "公司名称",
          keyName: "shname",
          placeholder: "请填写公司名称",
          type: "text",
        },
      ],
      cols: [
        { keyName: "con_num", label: "合同编号", minwidth: 110 },
        { keyName: "shname", label: "公司名称", minwidth: 150 },
        { keyName: "ton", label: "合同量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "caton", label: "计算量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "freight", label: "运费总额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "compen", label: "运单补差", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "contractmpen", label: "合同补差", align: 'right', className: 'pr30', minwidth: 120 },
        //{ keyName: "cprice", label: "运费单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "ys_freight", label: "应收运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "yf_freight", label: "应付运费", align: 'right', className: 'pr30', minwidth: 120 },
        //{ keyName: "yingshou", label: "应收账款", align: 'right', className: 'pr30', minwidth: 120 },
        //{ keyName: "yingfu", label: "应付账款", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      getTotalProperty: ['kuiton', 'kuitotal', 'freight', 'compen', 'ys_freight', 'yf_freight', 'contractmpen', 'caton'],
      btns: [
        {
          title: '统计',
          img: require('@/assets/img/icon_count.png'),
          unimg: require('@/assets/img/icon_count_hover.png'),
          cb: ({ id }) => {
            // this.$router.push(
            //   `/finance/statistics?id=${id}`
            // );
            this.$router.push(
              `/finance/carlist?id=${id}`
            );
          },
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped></style>
